/**
 * Scoring barrel — re-exports the public surface of the scoring module.
 */

export type { CorridorOpts, HabitatCorridor } from "./corridor";
export { corridorScoreForSize, findHabitatCorridors } from "./corridor";
export { applyLandmarkEffects } from "./landmark";
export type { MajorityResult, PlayerCorridorInput } from "./majority";
export { scoreHabitatMajority } from "./majority";
export { scoreNatureTokens } from "./nature";
export { scoreGame } from "./score-game";
export type { PlayerScore } from "./tiebreak";
export { computeWinners } from "./tiebreak";
export {
  scoreAdjacentDistinctSpecies,
  scoreGroupsOfSize,
  scoreLines,
  scorePairsWithinDistance,
  scoreSurroundingTileCount,
  scoreWildlifeForPlayer,
} from "./wildlife";
